import { Action, Reducer } from 'redux';
import { RemoteDataAreaState } from './types-store';
import { ACTION, AddQueryParam } from './action-types';

export const INITIAL_REMOTE_DATA_STATE: RemoteDataAreaState = {
  query: {}
};

const reducers: { [indexer: string]: Reducer<RemoteDataAreaState, Action> } = {
  [ACTION.ADD_QUERY_PARAM]: (state: RemoteDataAreaState, action: AddQueryParam): RemoteDataAreaState => {
    return {
      ...state,
      query: {
        ...state.query,
        [action.queryParam]: action.value
      }
    };
  }
};

export const reducer: Reducer<RemoteDataAreaState> = (
  state: RemoteDataAreaState = INITIAL_REMOTE_DATA_STATE, action: any) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
